<div class="attribute-image">

  @if (templateAttribute.labelDictionaryKey) {
    <div class="title" >
      <label [attr.for]="templateAttribute.key">
        <sc-dictionary-label [dictionaryKey]="templateAttribute.labelDictionaryKey"></sc-dictionary-label>
      </label>
    </div>
  }

  <div class="image-content-area">

    @for (td of images; track td) {
      <mat-card class="card preview">
        <sc-action-icon iconClass="fa-times-circle" class="delete-icon" (click)="removeImage(td)"></sc-action-icon>
        <img [src]="createPreviewUrl(td)" class="capture" height="100" (click)="showImagePreview(td)"/>
      </mat-card>
    }

  </div>

  <div class="buttonbar">
    <label for="picture-btn-{{templateAttribute.key}}" title="
        {{'take picture' | translate:['tmc.transport-details.dialog.documents.take-picture',
        translationService.language]}}"><i class="picture-icon fa-light fa-camera"></i></label>
      <input id="picture-btn-{{templateAttribute.key}}" name="picture-btn-{{templateAttribute.key}}" class="picture-input-field" type="file" accept="image/*"
        (change)="handleDocumentPictureEvent($event)" [disabled]="templateAttribute.mode === attributeMode.DISABLED"/>
      </div>

      <!-- Loading spinner to prevent user from doing anything during validation. -->
      @if (requestRunning) {
        <div class="loading-spinner">
          <i class="spinner fa-light fa-spinner fa-spin"></i>
        </div>
      }

    </div>
